import { api } from "./api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Encola el recálculo COREX (POST → 202 + jobId) y hace polling del estado en Mongo hasta un estado
// TERMINAL. Devuelve { status, total?, error? } con status ∈ COMPLETED | ERROR | TIMEOUT.
// - Mientras el job siga PENDING/RUNNING NO retorna (los controles del caller permanecen bloqueados).
// - Tras 180s sin terminar avisa vía onProgress("STILL_RUNNING") y sigue con menor frecuencia, con un
//   tope absoluto de 10min para no quedar en bucle infinito.
export async function runRecalc({ onProgress } = {}) {
  const SOFT = Date.now() + 180000;   // aviso "COREX continúa procesando…"
  const HARD = Date.now() + 600000;   // tope absoluto (evita bucle infinito)
  let jobId = null;

  // 1) Encolar (reintenta si el clon aún se está inicializando en segundo plano)
  while (Date.now() < SOFT) {
    const { data } = await api.post("/vm/estructural/bridge-corex-override");
    if (data?.jobId) { jobId = data.jobId; onProgress?.(data.status || "PENDING"); break; }
    if (data?.status === "INITIALIZING") { onProgress?.("INITIALIZING"); await sleep(3000); continue; }
    return { status: "ERROR", error: "Respuesta inesperada del servidor." };
  }
  if (!jobId) return { status: "TIMEOUT" };

  // 2) Polling hasta estado terminal
  while (Date.now() < HARD) {
    const soft = Date.now() > SOFT;
    await sleep(soft ? 8000 : 2500);
    let st;
    try { ({ data: st } = await api.get(`/vm/estructural/recalc-status/${jobId}`)); }
    catch (e) { continue; }   // error transitorio → reintenta dentro del tope
    if (st.status === "COMPLETED") return { status: "COMPLETED", total: st.total };
    if (st.status === "ERROR")     return { status: "ERROR", error: st.error };
    onProgress?.(soft ? "STILL_RUNNING" : (st.status || "RUNNING"));
  }
  return { status: "ERROR", error: "El recálculo excedió el tiempo máximo. Reintenta." };
}
